"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_onclickout_1 = __importDefault(require("react-onclickout"));
/** Palette item that allows picking from dropdown */
class DropdownPaletteItem extends react_1.default.Component {
    static defaultProps = { position: "under" };
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            moreOpen: false
        };
    }
    handleMouseDown = (ev) => {
        // Ignore if clicking on menu
        if (ev.target.className === "dropdown-palette-menu-item") {
            return;
        }
        // Don't lose focus from editor
        ev.preventDefault();
        this.setState({ open: !this.state.open });
    };
    handleMoreClick = (ev) => {
        ev.preventDefault();
        this.setState({ moreOpen: true });
    };
    renderItem(item) {
        return (react_1.default.createElement("div", { className: "dropdown-palette-menu-item", onMouseDown: (ev) => {
                ev.preventDefault();
                this.props.onSelect(item.value);
                this.setState({ open: false });
            }, key: item.value }, item.label));
    }
    renderItems() {
        const visibleItems = this.state.moreOpen ? this.props.items : this.props.items.filter(item => !item.more);
        const halfLength = Math.ceil(visibleItems.length / 2);
        const leftColumn = visibleItems.slice(0, halfLength);
        const rightColumn = visibleItems.slice(halfLength);
        return (react_1.default.createElement("div", { className: "dropdown-palette-menu" },
            react_1.default.createElement("div", { style: { display: 'flex' } },
                react_1.default.createElement("div", { style: { flex: 1 } }, leftColumn.map(item => this.renderItem(item))),
                react_1.default.createElement("div", { style: { flex: 1 } }, rightColumn.map(item => this.renderItem(item)))),
            this.props.items.some(item => item.more) && !this.state.moreOpen && (react_1.default.createElement("div", { className: "dropdown-palette-menu-item", onMouseDown: this.handleMoreClick }, T `More...`))));
    }
    render() {
        const popupPosition = {
            position: "absolute",
            left: 0,
            zIndex: 1000,
            backgroundColor: "white",
            border: "solid 1px #AAA",
            borderRadius: 3
        };
        if (this.props.position === "under") {
            popupPosition.top = 26;
        }
        else {
            popupPosition.bottom = 26;
        }
        return (react_1.default.createElement(react_onclickout_1.default, { onClickOut: () => this.setState({ open: false, moreOpen: false }) },
            react_1.default.createElement("div", { className: "mwater-visualization-text-palette-item", style: { position: "relative" }, onMouseDown: this.handleMouseDown },
                react_1.default.createElement("style", null, `
              .dropdown-palette-menu-item {
                color: black;
                background-color: white;
                text-align: left;
                padding: 5px 15px 5px 15px;
                cursor: pointer;
              }
              .dropdown-palette-menu-item:hover {
                background-color: #DDD;
              }
            `),
                this.state.open ? react_1.default.createElement("div", { style: popupPosition }, this.renderItems()) : undefined,
                this.props.label)));
    }
}
exports.default = DropdownPaletteItem;
